import * as React from 'react';
import * as styles from './ContentCreatorItem.css';
import { IAIcon } from '../../icon/Icon';
import { ContentCreatorStore } from '../stores';
import { inject, observer } from 'mobx-react';
import ContentCreatorService from '../../../services/ContentCreatorService';
import { IContentCreator } from '../../../interfaces/IContentCreator';

export interface IProps {
  contentCreatorStore?: ContentCreatorStore;
  index?: number;
  icon?: string;
  title?: string;
  color?: string;
  description?: string;
}

export interface IState {
}

@inject('contentCreatorStore')
@observer
export class ContentCreatorItem extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
    };
  }

  public render(): JSX.Element {
    return (
        <div
          className={styles.IA_addNewButton}
          draggable={!this.props.contentCreatorStore.isSaving}
          onDragStart={() => {
            this.props.contentCreatorStore.isDraggingItemWithIndex = this.props.index;
            this.props.contentCreatorStore.addDroppableItemAtIndex(this.props.index);
          }}
          onDragEnd={() => {
            console.log("onDragEnd");
            this.props.contentCreatorStore.isSaving = true;
            const contentCreator: IContentCreator = {
              id: this.props.contentCreatorStore.id,
              title:  this.props.contentCreatorStore.title,
              config: this.props.contentCreatorStore.items
            }
            ContentCreatorService.update(this.props.contentCreatorStore.environment, this.props.contentCreatorStore.token, this.props.contentCreatorStore.tenant, this.props.contentCreatorStore.instance.instanceName, contentCreator).then(() => {
              this.props.contentCreatorStore.isSaving = false;
            }) 
          }}
          onDragEnter={() => {
            this.props.contentCreatorStore.isDraggingOverItemWithIndex(this.props.index);
          }}
          style={{
            opacity: this.props.contentCreatorStore.isSaving ? 0.5 : 1
          }}
        >
          <div className={styles.IA_icon}>
            <IAIcon
              title={this.props.icon}
              size={18}
              color={"#333333"}
            />
          </div>
          <div className={styles.IA_title}>{this.props.title}</div>
          <div
            className={styles.IA_icon}
            style={{
              float: "right"
            }}
          >
            <IAIcon
              title={"Move"}
              size={18}
              color={this.props.color}
            />
          </div>
          <div
            className={styles.IA_icon}
            style={{
              float: "right",
              marginRight: 0
            }}
            onClick={() => {
              this.props.contentCreatorStore.itemToEditIndex = this.props.index;
              this.props.contentCreatorStore.itemToEdit = this.props.contentCreatorStore.items[this.props.index];
              this.props.contentCreatorStore.itemToEditOriginal = Object.assign({}, this.props.contentCreatorStore.items[this.props.index]);
            }}
          >
            <IAIcon
              title={"Edit"}
              size={18}
              color={this.props.color}
            />
          </div>
        </div >
    );
  }
}